import { render, staticRenderFns } from "./card-info.vue?vue&type=template&id=4b4c5bae&scoped=true&"
import script from "./card-info.vue?vue&type=script&lang=js&"
export * from "./card-info.vue?vue&type=script&lang=js&"
import style0 from "./card-info.vue?vue&type=style&index=0&id=4b4c5bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4c5bae",
  null
  
)

export default component.exports